<template>
	<div class="bg-white px-3 index">
		<!-- <button-search class="pt-3">
			<template #right>
				<div class="d-flex align-items-center">
					<el-date-picker size="medium" v-model="search.time" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期">
					</el-date-picker>
					<el-input v-model="search.keyword" size="medium" placeholder="请输入订单号" style="width: 200px;"
						class="mx-2"></el-input>
					<el-button type="info" size="medium">搜索</el-button>
				</div>
			</template>
		</button-search> -->
		<el-tabs v-model="activeName" type="card" @tab-click="handleClick">
			<el-tab-pane label="医生账户资金" name="1">
				<yszhzj />
			</el-tab-pane>
			<el-tab-pane label="医生资金明细" name="2">
				<yszjmx />
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	import buttonSearch from "@/components/common/button-search.vue"
	import yszhzj from "./tabs/yszhzj.vue";
	import yszjmx from "./tabs/yszjmx.vue";
	export default {
		components: {
			buttonSearch,
			yszjmx,
			yszhzj,
		},
		data() {
			return {
				tableData: [],
				currentPage: 1,
				multipleSelection: [],

				search: {
					time: "",
					keyword: ""
				},
				activeName: '1'
			}
		},
		created() {

		},
		methods: {
			// 选中
			handleSelectionChange(val) {
				this.multipleSelection = val;
			},
			// 删除单个
			deleteItem(scope) {
				this.$confirm('是否要删除该规格?', '提示', {
					confirmButtonText: '删除',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.tableData.splice(scope.$index, 1)
					this.$message({
						message: '删除成功',
						type: 'success'
					});
				})
			},
			handleClick() {}
		},
	}
</script>

<style scoped>
	.index {
		padding-top: 10px;
	}

	.sku-list-item>i {
		display: none;
		cursor: pointer;
	}

	.sku-list-item:hover {
		background-color: #f4f4f4;
	}

	.sku-list-item:hover>font {
		display: none;
	}

	.sku-list-item:hover>i {
		display: inline-block;
	}
</style>